export const ProductLineCreations = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 6.60019C3 5.27471 4.07452 4.2002 5.4 4.2002H9.63108C10.1925 4.2002 10.7362 4.39703 11.1675 4.75646L12.5325 5.89393C12.9638 6.25336 13.5075 6.4502 14.0689 6.4502H18.6C19.9255 6.4502 21 7.52471 21 8.8502V17.4002C21 18.7257 19.9255 19.8002 18.6 19.8002H5.4C4.07452 19.8002 3 18.7257 3 17.4002V6.60019Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line stroke="currentColor" strokeWidth="1.5" x1="3.24023" x2="20.5736" y1="10.8901" y2="10.8901" />
  </svg>
);
